import { getCurrentRoom } from '../domain/dungeon/roomRules';
import type { GameStore } from './gameStore';

export const selectModeType = (state: GameStore) => state.mode.type;
export const selectMode = (state: GameStore) => state.mode;
export const selectPlayer = (state: GameStore) => state.player;
export const selectCombat = (state: GameStore) => state.combat;
export const selectDungeon = (state: GameStore) => state.dungeon;
export const selectCurrentRoomId = (state: GameStore) => state.dungeon.playerRoomId;
export const selectCurrentRoom = (state: GameStore) => getCurrentRoom(state.dungeon);
export const selectLastMessage = (state: GameStore) => state.lastMessage;
export const selectHasSave = (state: GameStore) => state.hasSave;
